<script setup lang="ts">
import { useWallet, WalletMultiButton } from 'solana-wallets-vue';
import { useAppStore } from '@/store/app';
import { watch } from 'vue';

const props = defineProps<{
  size?: 'x-large' | 'medium' | 'large';
  color?: 'primary' | 'secondary' | 'tertiary';
  variant?: 'tonal' | 'elevated';
  iconMode?: boolean;
}>();

const { ready, connect } = useWallet();

const store = useAppStore();
const connectWallet = () => {
  const button = document.getElementsByClassName('swv-button-trigger')[0] as
    | HTMLButtonElement
    | undefined;
  button?.click();
};

watch(ready, (r) => {
  if (r !== true) {
    return;
  }
  connect();
});
</script>

<template>
  <div>
    <v-btn
      v-if="iconMode"
      icon
      variant="tonal"
      @click="connectWallet"
      size="40"
    >
      <v-icon icon="mdi-wallet" size="18"></v-icon>
    </v-btn>
    <v-btn
      v-else
      @click="connectWallet"
      :color="props.color"
      :variant="props.variant"
      :size="props.size"
    >
      Connect Wallet
    </v-btn>
    <div class="hidden">
      <wallet-multi-button :dark="store.isDark" />
    </div>
  </div>
</template>
